<template>
  <div>
    <v-file-input
        :label="text"
        v-model="file"
        filled
        chips
        :prepend-icon="icon"
        :disabled="uploading && show_success"
        v-show="!show_success"
        :accept='accept'
    />
    <v-btn v-show="!uploading && !show_success" block color="secondary" @click="submitFile" :disabled="!file">
      {{$t('uploader.upload_button')}}
    </v-btn>
    <v-progress-linear v-show="uploading"
                       v-model="uploadPercentage"
                       color="secondary"
                       height="25"
    >
      <template v-slot:default="{ value }">
        <strong>{{ Math.ceil(value) }}%</strong>

      </template>
    </v-progress-linear>
    <v-row v-show="uploading">
      <v-col align="center">
        <v-chip small outlined color="error" @click="cancel_upload">
          <v-icon left>
            mdi-stop
          </v-icon>
          {{$t('uploader.stop_upload')}}
        </v-chip>
      </v-col>
    </v-row>
    <br>
    <v-row v-show="show_success">
      <v-col cols='12' align="center">
        <v-chip large color="#005C33" dark>
          <v-icon left>
            mdi-check
          </v-icon>
          {{$t('uploader.success_message')}}
        </v-chip>
      </v-col>
      <v-col cols='6' align="center">
        <v-chip dark outlined color="#FF5E00" @click="open_link(link)">
          <v-icon left>
            mdi-check
          </v-icon>
          {{ $t('uploader.link') }}
        </v-chip>
      </v-col>
      <v-col cols='6' align="center">
        <v-chip dark outlined color="#FF5E00" @click="re_upload">
          <v-icon left>
            mdi-refresh
          </v-icon>
          {{ $t('uploader.refresh') }}
        </v-chip>
      </v-col>
    </v-row>
    <v-row v-show="show_error">
      <v-col cols='6' align="center">
        <v-chip large color="error" dark>
          <v-icon left>
            mdi-close
          </v-icon>
          {{ $t('uploader.error_message') }}
        </v-chip>
      </v-col>

      <v-col cols='6' align="center">
        <v-chip dark large outlined color="#FF5E00" @click="re_upload">
          <v-icon left>
            mdi-refresh
          </v-icon>
          {{ $t('uploader.refresh') }}
        </v-chip>
      </v-col>
    </v-row>


  </div>
</template>

<script>
import axios from "axios";
import i18n from "../../i18n";

const CancelToken = axios.CancelToken;
let cancel;

export default {
  name: "Uploader",
  data() {
    return {
      file: null,
      uploadPercentage: 0,
      uploading: false,
      show_success: false,
      show_error: false,
      link: ''
    }
  },
  props: {
    url: String,
    type: String,
    upload_type: String,
    default_link: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: i18n.t('uploader.prop_text_string')
    },
    icon: {
      type: String,
      default: 'mdi-file'
    },
    accept:{
      type: String,
      default: 'video/*, .mkv'
    }
  },
  mounted() {
    if (this.default_link) {
      this.link = this.default_link
      this.show_success = true
      this.show_error = false
    }
  },
  methods: {
    open_link(link){
      window.open(link, '_blank');
    },
    re_upload() {
      let context = this
      this.$emit('re_upload', context.type)
      this.file = null
      this.show_success = false
      this.show_error = false
      this.uploading = false
      this.link = ''
    },
    submitFile: function () {


      let formData = new FormData();
      console.log('file', this.file)


      formData.append('file', this.file);
      formData.append('type', this.$props.upload_type);
      this.uploading = true

      let context = this
      this.$emit('is_uploading',context.uploading)


      let url = this.$props.url
      axios.post(url,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Authorization': "token " + localStorage.getItem('token')
            },
            cancelToken: new CancelToken(function executor(c) {
              cancel = c;
            }),
            onUploadProgress: function (progressEvent) {
              this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
            }.bind(this)
          }
      ).then(function (res) {
        context.show_success = true
        context.uploading = false
        context.$emit('is_uploading',context.uploading)
        context.link = res.data.file
        context.$emit('upload_succeed', {res: res.data, type: context.type})
      }).catch(function (err) {
        context.show_error = true
        context.show_success = false
        context.uploading = false
        context.$emit('is_uploading',context.uploading)
        context.$emit('upload_err', {err})
      });
    },
    cancel_upload: function () {
      cancel()
      this.uploading = false
    }
  }

}
</script>

<style scoped>

</style>
